<template>
    <el-dialog title="修改密码" :visible.sync="dialogFormVisible" :close-on-click-modal="false"
        :close-on-press-escape="false" :show-close="false" @close="close">
        <el-card>
            <p class="input-item">
                <el-input placeholder="请输入旧密码" v-model="old_password">
                    <template slot="prepend">请输入旧密码</template>
                </el-input>
            </p>
            <p class="input-item">
                <el-input placeholder="请输入新密码" v-model="new_password">
                    <template slot="prepend">请输入新密码</template>
                </el-input>
            </p>
            <p class="input-item">
                <el-input placeholder="请确认新密码" v-model="sub_password">
                    <template slot="prepend">请确认新密码</template>
                </el-input>
            </p>
        </el-card>
        <div slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="subChangePwd" :loading="loading">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { PWD_MIN_LENGTH } from '@/utils/utils';
import { Message } from 'element-ui';

export default {
    props: {
        dialogFormVisible: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            new_password: '',
            old_password: '',
            sub_password: '',
        }
    },
    created() {

    },
    methods: {
        close() {
            this.new_password = '';
            this.old_password = '';
            this.sub_password = '';
            this.$emit('close');
        },
        subChangePwd() {
            const { new_password, old_password, sub_password } = this;

            if (new_password.length < PWD_MIN_LENGTH || old_password.length < PWD_MIN_LENGTH || sub_password.length < PWD_MIN_LENGTH) {
                Message.error('密码最少六位');
                return
            }
            if (new_password !== sub_password) {
                Message.error('两次密码不一致');
                return
            }
            this.$emit('submit', {
                new_password,
                old_password
            })
        }
    },
}
</script>

<style lang='scss' scoped>
.input-item {
    margin-top: 12px;
}
</style>